import type {
  TObjectBulkEditJob,
  TObjectDeleteJob,
  TObjectExportJob,
  TObjectImportJob,
  TObjectJob,
} from './objectJob.type';

export const isBulkEditJob = (job: TObjectJob): job is TObjectBulkEditJob => {
  return [
    'EDIT_FIELDS',
    'EDIT_GENERAL_INFO',
    'EDIT_MEMBERS_AND_RELATIONS',
    'EDIT_ORGANIZATIONS',
  ].includes(job.operationType);
};

export const isExportJob = (job: TObjectJob): job is TObjectExportJob => {
  return job.operationType === 'EXPORT';
};

export const isDeleteJob = (job: TObjectJob): job is TObjectDeleteJob => {
  return job.operationType === 'DELETE';
};

export const isImportJob = (job: TObjectJob): job is TObjectImportJob => {
  return job.operationType === 'IMPORT';
};
